import styled from "@emotion/styled";

export const SectionContainer = styled.section`
margin: 50px auto;
height: auto;
width: 350px;
border-radius: 5px;
`;

export const Title = styled.h2`
 margin-bottom: 25px;
 text-align: center;
 color: black;
 font-size: 24px;
 font-weight: 700;
`;